
import React from 'react';
import {DonutChart} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';

class DonutData extends React.Component {
    constructor() {
        super();
    }
    
    render() {
        return (
            <div>
                <h2><strong>Results</strong></h2>
                <DonutChart 
                    data={this.props.dataObject[0]}
                    onClickSlice={this._onClickSlice}
                    labels={true}
                    legends={this.props.optionsObject.legends}
                    callouttext='[[title]]: [[value]]%'
                    tooltiptext='[[title]]: [[value]]%'
                ></DonutChart>
            </div>
        );
    }
}

export default DonutData;



// WEBPACK FOOTER //
// ./src/samples/run/pie.js